"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var clsx_1 = __importDefault(require("clsx"));
var IconButton_1 = __importDefault(require("../../../IconButton"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        padding: 6,
        color: theme.palette.grey[500],
        '&:hover': {
            color: theme.palette.grey[700],
        },
        fontSIze: '12px',
    },
    active: {
        color: theme.palette.grey[800],
        '&:hover': {
            color: theme.palette.grey[800],
        },
    },
    tooltip: {
        marginBottom: -16,
    },
}); });
var EditorToolbarButton = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var active = _a.active, alt = _a.alt, children = _a.children, className = _a.className, tooltip = _a.tooltip, disabled = _a.disabled, other = __rest(_a, ["active", "alt", "children", "className", "tooltip", "disabled"]);
    var classes = useStyles();
    return (react_1.default.createElement(Tooltip_1.default, { title: tooltip, placement: "top", enterDelay: 300, classes: { popper: classes.tooltip }, disableHoverListener: disabled, disableFocusListener: disabled, disableTouchListener: disabled },
        react_1.default.createElement("span", null,
            react_1.default.createElement(IconButton_1.default, __assign({ disableScaling: true, alt: alt, ref: ref, disabled: disabled, className: clsx_1.default(classes.root, (_b = {}, _b[classes.active] = active, _b), className) }, other), children))));
});
exports.default = EditorToolbarButton;
//# sourceMappingURL=EditorToolbarButton.js.map